import { render } from "./JobLogs.vue?vue&type=template&id=20604b76"
import script from "./JobLogs.vue?vue&type=script&lang=js"
export * from "./JobLogs.vue?vue&type=script&lang=js"

import "./JobLogs.vue?vue&type=style&index=0&id=20604b76&lang=css"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__